import { defineComponent as _defineComponent } from 'vue'
import { ref, watch } from "vue";

import { API_SYSTEM_IPC } from "@/configs/Apis";
import DuduAjax from "@/utils/DuduAjax";


export default /*#__PURE__*/_defineComponent({
  __name: 'IpcTag',
  props: {
  name: { type: String, default: () => "" },
  placement: { type: String, default: () => "left" },
},
  setup(__props) {

const props = __props;



const realName = ref("");
const data = ref<Array<any>>([]);

function updateData() {
  if (props.name === "") {
    data.value = [];
    return;
  }

  let ipc: string = props.name.trim();

  const firstChar = ipc.substr(0, 1);
  if (firstChar < "A" || firstChar > "H") {
    data.value = [];
    return;
  }

  if (ipc.indexOf("(") > 0) {
    ipc = ipc.substring(0, ipc.indexOf("("));
  }
  if (ipc.indexOf("（") > 0) {
    ipc = ipc.substring(0, ipc.indexOf("("));
  }
  realName.value = ipc;

  const cachedData = getFromCache();
  if (cachedData) {
    data.value = cachedData;
    return;
  }

  DuduAjax.get<Array<any>>({ url: API_SYSTEM_IPC + "?ipc=" + encodeURIComponent(realName.value), path: {} }, {}, false, false)
    .then((result) => {
      data.value = result || [];
      setToCache();
    })
    .catch(() => "");
}

function getFromCache() {
  const cachedStr = window.localStorage.getItem("IPC_CACHE_" + realName.value);
  if (!cachedStr) {
    return false;
  }

  refreshCacheKeys();

  const cachedData = JSON.parse(cachedStr);
  return cachedData;
}

function setToCache() {
  removeOldCache(); // LRU 保留最近访问的前300个
  window.localStorage.setItem("IPC_CACHE_" + realName.value, JSON.stringify(data.value));
  refreshCacheKeys();
}

function refreshCacheKeys() {
  const cachedKeys = window.localStorage.getItem("IPC_CACHE_KEYS") || "";
  window.localStorage.setItem("IPC_CACHE_KEYS", realName.value + "#" + cachedKeys.replace(realName.value + "#", ""));
}

function removeOldCache() {
  const cachedKeys = window.localStorage.getItem("IPC_CACHE_KEYS");
  if (!cachedKeys) {
    return;
  }

  const cachedKeyArr = cachedKeys.split("#");
  if (cachedKeyArr.length < 300) {
    return;
  }

  cachedKeyArr.pop();

  window.localStorage.setItem("IPC_CACHE_KEYS", cachedKeyArr.join("#") + "#");
}

updateData();

watch(
  () => props.name,
  () => {
    updateData();
  }
);

return { __sfc: true,props, realName, data, updateData, getFromCache, setToCache, refreshCacheKeys, removeOldCache }
}

})